import { VisibilityLayers } from '../../../../types/enums/VisibilityLayers';
import { VisibilityMap } from '../../../../types/VisibilityTypes';
import { useFeatureToggle } from '../../../common/useFeatureToggle';
import { VisibilityElements } from '../../configuration-canvas/types';
import { WithConfigurationCanvas } from '../../configuration-canvas/WithConfigurationCanvas';
import { HubspotCanvasPanel as DeprecatedHubspotCanvasPanel } from './HubspotCanvasPanel';
import { HubspotCanvasPanel } from './campaign-dialog/new/HubspotCanvasPanel';

const visibilityElements: Partial<VisibilityMap> = {
  [VisibilityLayers.NURTURING_STEPS]: true,
  [VisibilityLayers.COMMENTS]: false,
  [VisibilityLayers.FUNNEL_HUBSPOT_ENROLLMENTS]: false,
};

const visibilityElementsMap: VisibilityElements = {
  type: 'map',
  visibilityMap: visibilityElements,
};

export const CanvasHubspotPage = () => {
  const { hubspotV2Ft3 } = useFeatureToggle();
  return (
    <WithConfigurationCanvas visibilityElements={visibilityElementsMap}>
      {hubspotV2Ft3 ? <HubspotCanvasPanel /> : <DeprecatedHubspotCanvasPanel />}
    </WithConfigurationCanvas>
  );
};
